module.exports = __webpack_public_path__ + "static/media/be_url_icon.f37dfdf6.svg";